// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-devices-list {
  height: calc(100vh - 65px - 40px - 46px - 27px);
  overflow: hidden;
  overflow-y: scroll;
  margin-right: -17px;
}

.scrollable-sidebar {
  height: calc(100vh - 46px - 27px);
  overflow: hidden;
  overflow-y: scroll;
  margin-right: -17px;
}

.maintenance-dashboard-page {
  margin-top: 46px;
}

.fms-sidebar-wrapper {
  left: 50px;
  top: 46px;
  bottom: 27px;
  width: 275px;
  position: fixed;
  background: #fff;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
  transition: 0.3s ease;
  z-index: 8;
}
.fms-sidebar-wrapper + .main-view {
  margin-left: 285px;
}
.side-menu-open .fms-sidebar-wrapper {
  left: 195px;
}
.side-menu-close .fms-sidebar-wrapper {
  left: 50px;
}
.sidebar-collapse .fms-sidebar-wrapper + .main-view {
  margin-left: 0;
}

.fms-sidebar-wrapper2 {
  left: 0;
  width: 285px;
  position: fixed;
  margin-left: 195px;
  top: 46px;
  bottom: 27px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  z-index: 8;
}

.headerDiv {
  background: "transparent";
}

.searchBar {
  list-style-type: none;
  padding: 5px;
  margin-bottom: 3px;
  width: 200px;
}

.searchBarContractManagment {
  list-style-type: none;
  padding: 5px;
  margin-bottom: 3px;
  width: 300px;
}

.createBtn {
  background: #f9f9f9;
  list-style-type: none;
  padding-left: 0px;
  margin-left: 0px;
}

.fms-sidebar {
  width: 285px;
  position: fixed;
  left: 0;
  top: 40px;
  bottom: 40px;
  background: #fff;
  z-index: 8;
  overflow: hidden;
}
.fms-sidebar .section-head {
  padding: 5px;
  background: #f9f9f9;
  margin-bottom: 3px;
}
.fms-sidebar .filter-row {
  list-style-type: none;
  padding: 0;
  margin: 0;
  background: #f9f9f9;
}
.fms-sidebar .filter-row .active a {
  color: #00c179;
}
.fms-sidebar .filter-row .action-clear-list {
  color: #dc3545;
}
.fms-sidebar .filter-row .filter-nav {
  font-size: 12px;
}
.fms-sidebar .filter-row .filter-nav .add-group-link {
  vertical-align: middle;
}
.fms-sidebar .filter-row .filter-nav .add-group-link i {
  vertical-align: middle;
}
.fms-sidebar .filter-row .filter-nav .add-group-link i:hover {
  color: #00c179;
  font-weight: bold;
}
.fms-sidebar .filter-row .filter-nav .filter-nav-link {
  display: inline-block;
  vertical-align: middle;
  font-size: 12px;
  text-decoration: none;
  padding: 1px 5px 5px;
  margin-bottom: -5px;
  border-bottom: 1px solid transparent;
}
.fms-sidebar .filter-row .filter-nav .filter-nav-link:hover, .fms-sidebar .filter-row .filter-nav .filter-nav-link.active {
  color: #00c179;
  font-weight: bold;
  border-bottom-color: #00c179;
}
.fms-sidebar .v-divider {
  display: inline-block;
  vertical-align: top;
  border-left: 1px solid rgb(234.6, 234.6, 234.6);
  margin-left: 8px;
  margin-right: 8px;
  height: 21px;
}
.fms-sidebar {
  /* .individual-view {
  } */
}
.fms-sidebar .list-view, .fms-sidebar .list-view-group > li {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px;
}
.fms-sidebar .list-view .list-row, .fms-sidebar .list-view-group > li .list-row {
  padding: 5px;
  display: block;
  background: #fff;
  color: #666;
}
.fms-sidebar .list-view .list-row .hovered, .fms-sidebar .list-view-group > li .list-row .hovered {
  display: none;
  cursor: pointer;
}
.fms-sidebar .list-view .list-row:hover .hovered, .fms-sidebar .list-view-group > li .list-row:hover .hovered {
  display: inline-block;
}
.fms-sidebar .list-view .list-row:hover, .fms-sidebar .list-view-group > li .list-row:hover {
  background: #eee;
}
.fms-sidebar .list-view .list-row .pull-right, .fms-sidebar .list-view-group > li .list-row .pull-right {
  text-align: right;
  height: 26px !important;
}
.fms-sidebar .list-view a, .fms-sidebar .list-view-group > li a {
  color: inherit;
}
.fms-sidebar .list-view a i, .fms-sidebar .list-view-group > li a i {
  line-height: inherit;
}
.fms-sidebar .list-view .action-item, .fms-sidebar .list-view-group > li .action-item {
  font-size: 17px;
  padding-left: 2px;
  padding-right: 2px;
  line-height: 24px;
  margin-bottom: 5px !important;
}
.fms-sidebar .list-view .action-item i, .fms-sidebar .list-view-group > li .action-item i {
  color: inherit;
  vertical-align: middle;
}
.fms-sidebar .list-view .action-item.online, .fms-sidebar .list-view-group > li .action-item.online {
  color: #28a745;
}
.fms-sidebar .list-view .action-item.stop, .fms-sidebar .list-view-group > li .action-item.stop {
  color: #dc3545;
}
.fms-sidebar .list-view .action-item.offline, .fms-sidebar .list-view-group > li .action-item.offline {
  color: #999;
}
.fms-sidebar .list-view .action-item.away, .fms-sidebar .list-view-group > li .action-item.away {
  color: #ffc107;
}
.fms-sidebar .list-view .action-item .circle, .fms-sidebar .list-view-group > li .action-item .circle {
  margin-top: -0.2em;
}
.fms-sidebar .list-view .action-item .sub-menu, .fms-sidebar .list-view-group > li .action-item .sub-menu {
  min-width: 200px;
}
.fms-sidebar .list-view .action-view:hover, .fms-sidebar .list-view-group > li .action-view:hover {
  color: #00c179;
}
.fms-sidebar .list-view .action-clear-list, .fms-sidebar .list-view-group > li .action-clear-list {
  color: #dc3545;
}
.fms-sidebar .list-view .action-clear-list a, .fms-sidebar .list-view-group > li .action-clear-list a {
  cursor: pointer;
}
.fms-sidebar .list-view .action-ellipsis, .fms-sidebar .list-view-group > li .action-ellipsis {
  visibility: hidden;
}
.fms-sidebar .list-view-group > li > .list-row {
  background: #f9f9f9;
}
.fms-sidebar .group-view .list-view .list-view .list-row, .fms-sidebar .group-view .list-view-group > li .list-view .list-row, .fms-sidebar .group-view .list-view .list-view-group > li .list-row, .fms-sidebar .group-view .list-view-group > li .list-view-group > li .list-row {
  padding-left: 28px;
}
.fms-sidebar .group-view .list-view-group .list-row {
  padding-left: 5px;
}
.fms-sidebar .group-view .list-view-group .list-row .unit-name {
  font-weight: 600;
}
.fms-sidebar .action-view svg {
  max-width: 18px;
}
.fms-sidebar .action-running svg {
  max-width: 13px;
}
.fms-sidebar .action-accuracy svg {
  max-width: 16px;
}
.fms-sidebar .action-connection svg {
  max-width: 16px;
}
.fms-sidebar .action-battery svg {
  max-width: 21;
}
.fms-sidebar .action-additional-menu svg {
  max-width: 14px;
}
.fms-sidebar .action-clear-list svg {
  max-width: 11px;
}
.fms-sidebar .action-ellipsis svg {
  max-width: 6px;
}
.fms-sidebar .unit-name {
  cursor: pointer;
  max-width: 145px;
  min-width: 145px;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  text-overflow: ellipsis;
  line-height: 18px;
  margin-left: 10px;
  vertical-align: middle;
}
.fms-sidebar .unit-name img {
  max-width: 20px;
  height: auto;
  vertical-align: middle;
  margin-right: 5px;
}
.fms-sidebar .unit-details-box {
  background: #fff;
  padding: 10px;
  border-bottom: 1px solid rgb(229.5, 229.5, 229.5);
}
.fms-sidebar .unit-details-box .time-address-row {
  margin-top: 0;
  line-height: 1.7;
}
.fms-sidebar .unit-details-box .statistics-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin-bottom: 10px;
}
.fms-sidebar .unit-details-box .statistics-table td {
  text-align: center;
  border: 1px solid rgb(229.5, 229.5, 229.5);
  vertical-align: middle;
  padding: 10px;
}
.fms-sidebar .unit-details-box .caption-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
}
.fms-sidebar .unit-details-box .caption-table td {
  border: 1px solid rgb(229.5, 229.5, 229.5);
  vertical-align: middle;
  padding: 5px 10px;
}
.fms-sidebar .unit-details-box .caption-table th {
  border: 1px solid rgb(229.5, 229.5, 229.5);
  background: #fff;
  font-weight: normal;
  padding: 5px 10px;
}

.circle {
  width: 0;
  height: 0;
  border: 6px solid;
  border-radius: 50%;
  vertical-align: top;
  margin-top: 0.2em;
  margin-left: 3px;
  margin-right: 3px;
  display: inline-block;
}

.user-control-nav {
  padding: 0;
  margin: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background: #00c179;
}
.user-control-nav a {
  color: inherit;
}
.user-control-nav li {
  padding: 5px 10px 4px;
  color: #fff;
  display: inline-block;
}

@media (max-width: 959px) {
  .fms-sidebar-wrapper,
  .fms-sidebar {
    left: -285px;
  }
  .sidebar-collapse .fms-sidebar-wrapper,
  .sidebar-collapse .fms-sidebar {
    left: 6px;
  }
  .sidebar-devices-list,
  .scrollable-sidebar {
    margin-right: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/Layout/Sidebar/index.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAEA;EACE,+CAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AADF;;AAIA;EACE,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AADF;;AAGA;EACE,gBCEa;ADFf;;AAGA;EACE,UAAA;EACA,SAAA;EACA,YCHa;EDIb,YAAA;EACA,eAAA;EACA,gBCkCkB;EDjClB,2CAAA;EACA,qBAAA;EACA,UCgCc;ADhChB;AACE;EACE,kBCbW;ADcf;AACE;EACE,WAAA;AACJ;AAEE;EACE,UAAA;AAAJ;AAKI;EACE,cAAA;AAHN;;AAQA;EACE,OAAA;EACA,YCjCa;EDkCb,eAAA;EACA,kBAAA;EACA,SAAA;EACA,YCnCa;EDoCb,gBCIkB;EDFlB,sCAAA;EACA,UCEc;ADRhB;;AAQA;EACG,yBAAA;AALH;;AAOA;EACE,qBAAA;EACA,YAAA;EAEA,kBAAA;EACA,YAAA;AALF;;AAOA;EACE,qBAAA;EACA,YAAA;EAEA,kBAAA;EACA,YAAA;AALF;;AAOA;EACE,mBCjBc;EDkBd,qBAAA;EACA,iBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,YCpEa;EDqEb,eAAA;EACA,OAAA;EACA,SAAA;EACA,YAAA;EACA,gBC/BkB;EDkClB,UCjCc;EDkCd,gBAAA;AANF;AAQE;EACE,YAAA;EACA,mBCrCY;EDsCZ,kBAAA;AANJ;AASE;EACE,qBAAA;EACA,UAAA;EACA,SAAA;EACA,mBC7CY;ADsChB;AAmCI;EACE,cCrIO;ADoGb;AAmCI;EACE,cC7FK;AD4DX;AAoCI;EACE,eAAA;AAlCN;AAoCM;EACE,sBAAA;AAlCR;AAmCQ;EACE,sBAAA;AAjCV;AAkCU;EACE,cCnJC;EDoJD,iBAAA;AAhCZ;AAoCM;EACE,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EAEA,oCAAA;AAnCR;AAoCQ;EAEE,cCnKG;EDoKH,iBAAA;EACA,4BCrKG;ADkIb;AAyCE;EACE,qBAAA;EACA,mBAAA;EACA,+CAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAvCJ;AAxDA;EAkGE;KAAA;AAtCF;AAyCE;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,eCtHW;AD+Ef;AAwCI;EACE,YAAA;EAEA,cAAA;EACA,gBCpIS;EDqIT,WC1JK;ADmHX;AAwCM;EACE,aAAA;EACA,eAAA;AAtCR;AAyCQ;EACE,qBAAA;AAvCV;AAqCM;EAIE,gBC7IY;ADuGpB;AAwCM;EACE,iBAAA;EACA,uBAAA;AAtCR;AAyCI;EACE,cAAA;AAvCN;AAwCM;EACE,oBAAA;AAtCR;AAyCI;EACE,eClJa;EDmJb,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;AAvCN;AAwCM;EACE,cAAA;EACA,sBAAA;AAtCR;AAwCM;EACE,cCxLK;ADkJb;AAwCM;EACE,cC1LG;ADoJX;AAwCM;EACE,WCzLI;ADmJZ;AAwCM;EACE,cC9LM;ADwJd;AAwCM;EACE,kBAAA;AAtCR;AAwCM;EACE,gBAAA;AAtCR;AAyCI;EACE,cCrPO;AD8Mb;AA0CI;EACE,cC9MK;ADsKX;AAyCM;EACE,eAAA;AAvCR;AA2CI;EACE,kBAAA;AAzCN;AA+CI;EACE,mBC5MU;AD+JhB;AAkDI;EACE,kBAAA;AAhDN;AAkDI;EACE,iBAAA;AAhDN;AAiDM;EACE,gBAAA;AA/CR;AAoDE;EACE,eAAA;AAlDJ;AAoDE;EACE,eAAA;AAlDJ;AAoDE;EACE,eAAA;AAlDJ;AAoDE;EACE,eAAA;AAlDJ;AAoDE;EACE,aAAA;AAlDJ;AAoDE;EACE,eAAA;AAlDJ;AAoDE;EACE,eAAA;AAlDJ;AAoDE;EACE,cAAA;AAlDJ;AAqDE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;AAnDJ;AAoDI;EACE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;AAlDN;AAsDE;EACE,gBAAA;EACA,aAAA;EACA,iDAAA;AApDJ;AAqDI;EACE,aAAA;EACA,gBAAA;AAnDN;AAqDI;EACE,WAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAnDN;AAoDM;EACE,kBAAA;EACA,0CAAA;EACA,sBAAA;EACA,aAAA;AAlDR;AAqDI;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;AAnDN;AAoDM;EACE,0CAAA;EACA,sBAAA;EACA,iBAAA;AAlDR;AAoDM;EACE,0CAAA;EACA,gBCzSY;ED0SZ,mBAAA;EACA,iBAAA;AAlDR;;AAwDA;EACE,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,qBAAA;AAtDF;;AAyDA;EACE,UAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,mBC/XW;ADyUb;AAuDE;EACE,cAAA;AArDJ;AAuDE;EACE,qBAAA;EACA,WAAA;EACA,qBAAA;AArDJ;;AA2DA;EACE;;IAEE,YAAA;EAxDF;EA4DE;;IAEE,SAAA;EA1DJ;EA6DA;;IAEE,eAAA;EA3DF;AACF","sourcesContent":["@import \"./../../assets/variables\";\n\n.sidebar-devices-list {\n  height: calc(100vh - 65px - 40px - #{$headerHeight} - #{$footerHeight});\n  overflow: hidden;\n  overflow-y: scroll;\n  margin-right: -17px;\n}\n\n.scrollable-sidebar {\n  height: calc(100vh - #{$headerHeight} - #{$footerHeight});\n  overflow: hidden;\n  overflow-y: scroll;\n  margin-right: -17px;\n}\n.maintenance-dashboard-page {\n  margin-top: $headerHeight;\n}\n\n.fms-sidebar-wrapper {\n  left: 50px;\n  top: 46px;\n  bottom: $footerHeight;\n  width: $sidebarWidth - 10px;\n  position: fixed;\n  background: $sidebarBackground;\n  border-right: 1px solid rgba(black, 0.12);\n  transition: 0.3s ease;\n  z-index: $sidebarzIndex;\n  + .main-view {\n    margin-left: $sidebarWidth;\n  }\n  .side-menu-open & {\n    left: 195px;\n    \n  }\n  .side-menu-close & {\n    left: 50px;\n    \n  }\n\n  .sidebar-collapse & {\n    + .main-view {\n      margin-left: 0;\n    }\n  }\n    \n}\n.fms-sidebar-wrapper2 {\n  left: 0;\n  width: $sidebarWidth;\n  position: fixed;\n  margin-left: 195px;\n  top: 46px;\n  bottom: $footerHeight;\n  background: $sidebarBackground;\n  //border-right: 1px solid $borderColor;\n  box-shadow: 0 0 5px rgba(black, 0.2);\n  z-index: $sidebarzIndex;\n}\n.headerDiv{\n   background: 'transparent';\n}\n.searchBar{\n  list-style-type: none;\n  padding: 5px;\n  // background: $sidebarHeadBg;\n  margin-bottom: 3px;\n  width:200px\n}\n.searchBarContractManagment{\n  list-style-type: none;\n  padding: 5px;\n  // background: $sidebarHeadBg;\n  margin-bottom: 3px;\n  width:300px\n}\n.createBtn{\n  background: $sidebarHeadBg;\n  list-style-type: none;\n  padding-left: 0px;\n  margin-left: 0px;\n}\n\n.fms-sidebar {\n  width: $sidebarWidth;\n  position: fixed;\n  left: 0;\n  top: 40px;\n  bottom: 40px; //$footerHeight;\n  background: $sidebarBackground;\n  //border-right: 1px solid $borderColor;\n  // box-shadow: 0 0 5px rgba(black, 0.2);\n  z-index: $sidebarzIndex;\n  overflow: hidden;\n\n  .section-head {\n    padding: 5px;\n    background: $sidebarHeadBg;\n    margin-bottom: 3px;\n  }\n \n  .filter-row {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    background: $sidebarHeadBg;\n\n    // > li {\n    //   float: left;\n    //   color: $darkGrey;\n    // }\n    // .btn-group {\n    //   margin-left: 10px;\n    // }\n\n    // > li > a {\n    //   font-size: $baseIconFontSize;\n    //   padding-left: 2px;\n    //   padding-right: 2px;\n    //   color: inherit;\n    //   vertical-align: bottom;\n    //   line-height: 27px;\n    //   &:hover {\n    //     color: $themeColor;\n    //   }\n    //   svg {\n    //     vertical-align: top;\n    //     margin-top: 3px;\n    //   }\n    //   i {\n    //     line-height: inherit;\n    //   }\n    // }\n    .active a {\n      color: $themeColor;\n    }\n    .action-clear-list {\n      color: $redColor;\n    }\n\n    .filter-nav {\n      font-size: 12px;\n      // margin-left: 10px;\n      .add-group-link {\n        vertical-align: middle;\n        i {\n          vertical-align: middle;\n          &:hover {\n            color: $themeColor;\n            font-weight: bold;\n          }\n        }\n      }\n      .filter-nav-link {\n        display: inline-block;\n        vertical-align: middle;\n        font-size: 12px;\n        text-decoration: none;\n        padding: 1px 5px 5px;\n        margin-bottom: -5px;\n\n        border-bottom: 1px solid transparent;\n        &:hover,\n        &.active {\n          color: $themeColor;\n          font-weight: bold;\n          border-bottom-color: $themeColor;\n        }\n      }\n    }\n  }\n\n  .v-divider {\n    display: inline-block;\n    vertical-align: top;\n    border-left: 1px solid darken($sidebarRowBg, 8%);\n    margin-left: 8px;\n    margin-right: 8px;\n    height: 21px;\n  }\n\n  /* .individual-view {\n\t} */\n\n  .list-view {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    font-size: $baseFontSize;\n    .list-row {\n      padding: 5px;\n      //border-bottom: 1px solid darken($sidebarRowBg, 8%);\n      display: block;\n      background: $sidebarRowBg;\n      color: $sidebarRowColor;\n      .hovered {\n        display: none;\n        cursor: pointer;\n      }\n      &:hover {\n        .hovered {\n          display: inline-block;\n        }\n        background: $sidebarRowHoverBg;\n      }\n      .pull-right {\n        text-align: right;\n        height: 26px !important;\n      }\n    }\n    a {\n      color: inherit;\n      i {\n        line-height: inherit;\n      }\n    }\n    .action-item {\n      font-size: $baseIconFontSize;\n      padding-left: 2px;\n      padding-right: 2px;\n      line-height: 24px;\n      margin-bottom: 5px !important;\n      i {\n        color: inherit;\n        vertical-align: middle;\n      }\n      &.online {\n        color: $greenColor;\n      }\n      &.stop {\n        color: $redColor;\n      }\n      &.offline {\n        color: $lightGrey;\n      }\n      &.away {\n        color: $yellowColor;\n      }\n      .circle {\n        margin-top: -0.2em;\n      }\n      .sub-menu {\n        min-width: 200px;\n      }\n    }\n    .action-view:hover {\n      color: $skyColor;\n    }\n\n    .action-clear-list {\n      color: $redColor;\n      a {\n        cursor: pointer;\n      }\n    }\n\n    .action-ellipsis {\n      visibility: hidden;\n    }\n  }\n  .list-view-group > li {\n    @extend .list-view;\n\n    > .list-row {\n      background: $sidebarHeadBg;\n    }\n  }\n\n  .group-view {\n    .list-view .list-view .list-row {\n      padding-left: 28px;\n    }\n    .list-view-group .list-row {\n      padding-left: 5px;\n      .unit-name {\n        font-weight: 600;\n      }\n    }\n  }\n\n  .action-view svg {\n    max-width: 18px;\n  }\n  .action-running svg {\n    max-width: 13px;\n  }\n  .action-accuracy svg {\n    max-width: 16px;\n  }\n  .action-connection svg {\n    max-width: 16px;\n  }\n  .action-battery svg {\n    max-width: 21;\n  }\n  .action-additional-menu svg {\n    max-width: 14px;\n  }\n  .action-clear-list svg {\n    max-width: 11px;\n  }\n  .action-ellipsis svg {\n    max-width: 6px;\n  }\n\n  .unit-name {\n    cursor: pointer;\n    max-width: 145px;\n    min-width: 145px;\n    overflow: hidden;\n    white-space: nowrap;\n    display: inline-block;\n    text-overflow: ellipsis;\n    line-height: 18px;\n    margin-left: 10px;\n    vertical-align: middle;\n    img {\n      max-width: 20px;\n      height: auto;\n      vertical-align: middle;\n      margin-right: 5px;\n    }\n  }\n\n  .unit-details-box {\n    background: #fff;\n    padding: 10px;\n    border-bottom: 1px solid $borderColor;\n    .time-address-row {\n      margin-top: 0;\n      line-height: 1.7;\n    }\n    .statistics-table {\n      width: 100%;\n      border-collapse: collapse;\n      font-size: $baseFontSize + 2;\n      margin-bottom: 10px;\n      td {\n        text-align: center;\n        border: 1px solid $borderColor;\n        vertical-align: middle;\n        padding: 10px;\n      }\n    }\n    .caption-table {\n      width: 100%;\n      border-collapse: collapse;\n      margin-bottom: 10px;\n      td {\n        border: 1px solid $borderColor;\n        vertical-align: middle;\n        padding: 5px 10px;\n      }\n      th {\n        border: 1px solid $borderColor;\n        background: $sidebarBackground;\n        font-weight: normal;\n        padding: 5px 10px;\n      }\n    }\n  }\n}\n\n.circle {\n  width: 0;\n  height: 0;\n  border: 6px solid;\n  border-radius: 50%;\n  vertical-align: top;\n  margin-top: 0.2em;\n  margin-left: 3px;\n  margin-right: 3px;\n\n  display: inline-block;\n}\n\n.user-control-nav {\n  padding: 0;\n  margin: 0;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  text-align: center;\n  background: $themeColor;\n  a {\n    color: inherit;\n  }\n  li {\n    padding: 5px 10px 4px;\n    color: #fff;\n    display: inline-block;\n  }\n}\n\n// responsive\n\n@media (max-width: 959px) {\n  .fms-sidebar-wrapper,\n  .fms-sidebar {\n    left: -$sidebarWidth;\n  }\n\n  .sidebar-collapse {\n    .fms-sidebar-wrapper,\n    .fms-sidebar {\n      left: 6px;\n    }\n  }\n  .sidebar-devices-list,\n  .scrollable-sidebar {\n    margin-right: 0;\n  }\n}\n","@import 'functions';\n@import 'mixins';\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import 'bs_variables';\n\n// Layouts\n$sidebarWidth: 285px;\n$headerHeight: 46px;\n$footerHeight: 27px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n// Header\n\n$borderColor: darken(white, 10%);\n$linkColor: #666;\n$hoverBg: darken($themeColor, 3%);\n$hoverColor: #fff;\n$hoverBorderColor: darken($themeColor, 10%);\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #fff;\n$blue: #012d55;\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #f3f3f3;\n$lightGrey: #999;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n$danger: $redColor;\n$warning: $yellowColor;\n$success: $greenColor;\n\n// Sidebar\n$sidebarBackground: #fff;\n$sidebarzIndex: 8;\n$sidebarHeadBg: #f9f9f9;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #eee;\n$sidebarRowColor: $darkGrey;\n\n// Footer\n\n$footerBackground: $themeColor;\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n$baseFontFamily: 'Open Sans', sans-serif;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
